var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Container",
    [
      [
        _vm.donationWayType.ECPAY_SINGLE_ATM,
        _vm.donationWayType.ECPAY_SINGLE_CVS,
      ].includes(_vm.donationWay)
        ? _c("Title", { attrs: { strong: "", bold: "" } }, [
            _vm._v(" 付款資訊 "),
          ])
        : _c("Title", { attrs: { strong: "", bold: "" } }, [
            _vm._v(" 捐款結果 "),
          ]),
      _c(
        "Form",
        [
          _c(
            "FormCard",
            [
              _c("BreadCrumb", { attrs: { items: _vm.breadCrumbitems } }),
              _c("FormHeading", [
                _vm.submitted && !_vm.submittedError
                  ? _c("span", [_vm._v("謝謝您的支持")])
                  : _vm.submitted && _vm.submittedError
                  ? _c("span", [_vm._v("捐款失敗")])
                  : _vm._e(),
              ]),
              _vm.donationPeriod == _vm.donationPeriodType.DONATION_SINGLE
                ? [
                    _c(
                      "FormRow",
                      [
                        _c("PreviewSectionTitle", [
                          _vm._v(" " + _vm._s(_vm.donationWay + "資訊") + " "),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { class: _vm.$style.orderInfo },
                      [
                        _vm.donationWay === _vm.donationWayType.ECPAY_SINGLE_ATM
                          ? [
                              _c("FormRow", [
                                _vm._v(
                                  "跨行轉帳若非使用同銀行ATM櫃員機，須支付跨行手續費 15 元，請務必於繳費期限內進行繳費（若使用第一銀行ATM櫃員機，請選擇「繳費」按鈕）"
                                ),
                              ]),
                            ]
                          : _vm.donationWay ===
                            _vm.donationWayType.ECPAY_SINGLE_CVS
                          ? [
                              _c("FormRow", [
                                _vm._v(
                                  "請至 7-ELEVEN / 全家 / 萊爾富 / OK 超商 多媒體機台列印繳費單繳費"
                                ),
                              ]),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    [
                      _vm.donationWayType.ECPAY_SINGLE_ATM,
                      _vm.donationWayType.ECPAY_SINGLE_CVS,
                      _vm.donationWayType.ECPAY_SINGLE_CREDIT,
                    ].includes(_vm.donationWay)
                      ? [
                          _c(
                            "FormRow",
                            _vm._l(
                              _vm.formattedEcpayInfo,
                              function (item, index) {
                                return _c("PreviewField", {
                                  key: index,
                                  attrs: { name: item.name, value: item.value },
                                })
                              }
                            ),
                            1
                          ),
                        ]
                      : _vm.donationWay === _vm.donationWayType.JKOPAY_SINGLE
                      ? [
                          _c(
                            "FormRow",
                            _vm._l(
                              _vm.formattedJKOPayInfo,
                              function (item, index) {
                                return _c("PreviewField", {
                                  key: index,
                                  attrs: { name: item.name, value: item.value },
                                })
                              }
                            ),
                            1
                          ),
                        ]
                      : _vm.donationWay === _vm.donationWayType.LINEPAY_SINGLE
                      ? [
                          _c(
                            "FormRow",
                            _vm._l(
                              _vm.formattedLinePayInfo,
                              function (item, index) {
                                return _c("PreviewField", {
                                  key: index,
                                  attrs: { name: item.name, value: item.value },
                                })
                              }
                            ),
                            1
                          ),
                        ]
                      : [
                          _c(
                            "FormRow",
                            _vm._l(
                              _vm.formattedJKOPayInfo,
                              function (item, index) {
                                return _c("PreviewField", {
                                  key: index,
                                  attrs: { name: item.name, value: item.value },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                    _vm.isATMOverLimit
                      ? _c("div", { class: _vm.$style.warningInfo }, [
                          _c("p", [
                            _vm._v(
                              " 提醒您，由於捐款金額大於 3 萬元，需至以下銀行之實體ATM櫃員機，使用「繳費功能」完成捐款，謝謝！ "
                            ),
                          ]),
                          _c("p", [
                            _vm._v(
                              " 銀行列表：台新銀行、玉山銀行、中國信託、華南銀行、第一銀行、富邦銀行、台灣銀行、土地銀行、彰化銀行、永豐銀行、國泰世華銀行。 "
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm.donationPeriod !== _vm.donationPeriodType.DONATION_SINGLE
                ? [
                    _c(
                      "FormRow",
                      [_c("PreviewSectionTitle", [_vm._v("捐款資訊")])],
                      1
                    ),
                    _vm.donationWay === _vm.donationWayType.LINEPAY_PERIOD
                      ? [
                          _c(
                            "FormRow",
                            _vm._l(
                              _vm.formattedLinePayInfo,
                              function (item, index) {
                                return _c("PreviewField", {
                                  key: index,
                                  attrs: { name: item.name, value: item.value },
                                })
                              }
                            ),
                            1
                          ),
                        ]
                      : [
                          _c(
                            "FormRow",
                            _vm._l(
                              _vm.formattedEcpayInfo,
                              function (item, index) {
                                return _c("PreviewField", {
                                  key: index,
                                  attrs: { name: item.name, value: item.value },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                  ]
                : _vm._e(),
              _vm.hasReceiptInfo && !_vm.isAnonymous
                ? [
                    _c(
                      "FormRow",
                      [_c("PreviewSectionTitle", [_vm._v("收據資訊")])],
                      1
                    ),
                    _c(
                      "FormRow",
                      _vm._l(_vm.formattedReceiptInfo, function (item, index) {
                        return _c("PreviewField", {
                          key: index,
                          attrs: { name: item.name, value: item.value },
                        })
                      }),
                      1
                    ),
                  ]
                : _vm._e(),
              _c(
                "div",
                { class: _vm.$style.warningInfo },
                [
                  _c("FormRow", [
                    _c("p", [
                      _vm._v(
                        " 提醒您，請勿按上一頁或重新整理，避免資料重複送出，謝謝！"
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _c("br"),
              _c(
                "Align",
                { attrs: { right: "" } },
                [
                  _c(
                    "Button",
                    {
                      attrs: { small: _vm.isMobile },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.submit()
                        },
                      },
                    },
                    [_vm._v(" 確認 ")]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _vm.isMobile
            ? _c("div", { class: _vm.$style.linePromotion }, [
                _c("p", { class: _vm.$style.linePromotionText }, [
                  _vm._v(" 歡迎加入 LINE 官方帳號，"),
                  _c("br"),
                  _vm._v("第一時間收到 TFT 最新活動與故事分享 "),
                ]),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://urli.ai/line/qrcode_773rbvqs?muid=bot-j76oi#",
                      target: "_blank",
                      rel: "noopener noreferrer",
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: "https://scdn.line-apps.com/n/line_add_friends/btn/zh-Hant.png",
                        alt: "加入好友",
                        height: "36",
                        border: "0",
                      },
                    }),
                  ]
                ),
              ])
            : _vm._e(),
          _c("p", { class: _vm.$style.text }, [
            _vm._v(" 如有任何問題，歡迎寄信至 fin@teach4taiwan.org 詢問 "),
          ]),
        ],
        1
      ),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.showLinePopup && !_vm.isMobile
          ? _c("div", { class: _vm.$style.linePopupOverlay }, [
              _c("div", { class: _vm.$style.linePopup }, [
                _c(
                  "button",
                  {
                    class: _vm.$style.linePopupClose,
                    on: { click: _vm.closeLinePopup },
                  },
                  [_vm._v(" × ")]
                ),
                _c("p", { class: _vm.$style.linePopupTitle }, [
                  _vm._v(" 想收到有關 TFT 活動的最新消息"),
                  _c("br"),
                  _vm._v("與故事分享嗎？ "),
                ]),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://urli.ai/line/qrcode_773rbvqs?muid=bot-j76oi#",
                      target: "_blank",
                      rel: "noopener noreferrer",
                    },
                  },
                  [
                    _c("img", {
                      class: _vm.$style.linePopupQR,
                      attrs: {
                        src: require("@/images/line-friend-qrcode.png"),
                        alt: "LINE QR Code",
                      },
                    }),
                  ]
                ),
                _c("p", { class: _vm.$style.linePopupSubText }, [
                  _vm._v(" 歡迎加入 LINE 官方帳號，讓您不"),
                  _c("br"),
                  _vm._v("錯過任何 TFT 的消息！ "),
                ]),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://urli.ai/line/qrcode_773rbvqs?muid=bot-j76oi#",
                      target: "_blank",
                      rel: "noopener noreferrer",
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: "https://scdn.line-apps.com/n/line_add_friends/btn/zh-Hant.png",
                        alt: "加入好友",
                        height: "36",
                        border: "0",
                      },
                    }),
                  ]
                ),
              ]),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }